import { AppLayout } from "../shared";
import JoinRequests from "../MasterOrg/JoinRequests";

const MasterOrgJoinRequests_layout = ({ props, setIsLoaded }) => {
  return (
    <AppLayout props={props}>
      <JoinRequests props={props} setIsLoaded={setIsLoaded} />
    </AppLayout>
  );
};

export default MasterOrgJoinRequests_layout;
